import React from 'react';
import Layout from '../../components/Layout';
import { PageProps } from '../../App';
import { Link } from 'react-router-dom';

const LupaCastPage: React.FC<PageProps> = ({ darkMode, toggleDarkMode }) => {
  return (
    <Layout darkMode={darkMode} toggleDarkMode={toggleDarkMode}>
      <div className="bg-white dark:bg-gray-900">
        {/* Hero Section */}
        <div className="relative bg-gradient-to-r from-lupa-orange to-lupa-yellow overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-lupa-purple-dark/70 to-lupa-purple/30 z-10"></div>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 relative z-20">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight font-heading">
                Lupa Cast
              </h1>
              <p className="mt-6 text-xl text-white/90 max-w-3xl mx-auto">
                A plataforma avançada de forecast que transforma seus dados em previsões precisas e conversas estratégicas.
              </p>
            </div>
          </div>
          <div className="absolute bottom-0 left-0 right-0">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="w-full h-auto">
              <path fill="#ffffff" fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,149.3C960,160,1056,160,1152,138.7C1248,117,1344,75,1392,53.3L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
            </svg>
          </div>
        </div>

        {/* Conteúdo Principal */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-6">Forecast Inteligente para Decisões Estratégicas</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                O Lupa Cast é nossa plataforma especializada em <span className="font-semibold text-lupa-orange">forecast</span> que utiliza algoritmos avançados de Machine Learning para transformar dados históricos em previsões precisas e acionáveis para seu negócio.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Desenvolvido para atender às necessidades de planejamento de vendas, gestão de estoque e otimização de recursos, o Lupa Cast vai além das simples projeções numéricas, oferecendo <span className="font-semibold text-lupa-orange">insights contextualizados</span> que explicam os "porquês" por trás de cada previsão.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Com a integração opcional com nossa solução <span className="font-semibold">LIA</span> (Lupa Inteligência Artificial), seus dados ganham voz, Literalmente. Você pode fazer perguntas em linguagem natural, explorar cenários alternativos e obter explicações detalhadas sobre as previsões, como se estivesse conversando com um especialista em análise de dados.
              </p>
              <div className="mt-8">
                <a href="/contato" className="btn-primary">
                  Descubra o Lupa Cast
                </a>
              </div>
            </div>
            <div className="bg-gray-100 dark:bg-gray-800 p-8 rounded-xl shadow-lg">
              <h3 className="text-2xl font-bold text-lupa-purple dark:text-white mb-4">Benefícios Principais</h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
                  <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Previsões:</span> Algoritmos de Machine Learning que aprendem continuamente para forecasts cada vez mais assertivos.</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
                  <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Análise:</span> Considera fatores externos como sazonalidade, tendências de mercado e eventos especiais.</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
                  <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Visualização Intuitiva:</span> Dashboards interativos que transformam dados complexos em insights visuais claros.</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
                  <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Simulação de Cenários:</span> Teste diferentes estratégias e veja o impacto projetado nos resultados futuros.</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
                  <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Integração com LIA:</span> Converse com seus dados através de nossa IA conversacional para insights mais profundos.</span>
                </li>
              </ul>
            </div>
          </div>

          {/* A Ciência por Trás do Forecast */}
          <div className="mt-20">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-8 text-center">A Ciência por Trás do Forecast</h2>
            <div className="bg-white dark:bg-gray-800 p-8 rounded-xl shadow-lg">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-2xl font-bold text-lupa-purple dark:text-white mb-4">Machine Learning Avançado</h3>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    O Lupa Cast utiliza uma combinação de algoritmos de Machine Learning especialmente selecionados para tarefas de previsão temporal, incluindo:
                  </p>
                  <ul className="space-y-2 mb-6">
                    <li className="flex items-start">
                      <svg className="h-5 w-5 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                      </svg>
                      <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Redes Neurais Recorrentes (RNN/LSTM)</span> para capturar dependências temporais complexas</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-5 w-5 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                      </svg>
                      <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Gradient Boosting</span> para modelagem preditiva de alta precisão</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-5 w-5 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                      </svg>
                      <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Modelos Prophet</span> para detecção de sazonalidade e tendências</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-5 w-5 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                      </svg>
                      <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Ensemble Methods</span> que combinam múltiplos modelos para maior robustez</span>
                    </li>
                  </ul>
                  <p className="text-gray-700 dark:text-gray-300">
                    Nossa abordagem de <Link to="/tecnologias/machine-learning" className="text-lupa-orange hover:underline">Machine Learning</Link> é adaptativa, selecionando automaticamente os melhores algoritmos para cada tipo de dado e cenário de negócio, garantindo previsões otimizadas para seu contexto específico.
                  </p>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-lupa-purple dark:text-white mb-4">Análise Multidimensional</h3>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    O Lupa Cast vai além dos dados internos da sua empresa, incorporando fatores externos que impactam seu negócio:
                  </p>
                  <ul className="space-y-2 mb-6">
                    <li className="flex items-start">
                      <svg className="h-5 w-5 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                      </svg>
                      <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Tendências de Mercado</span> e indicadores econômicos relevantes</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-5 w-5 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                      </svg>
                      <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Sazonalidades</span> específicas do seu setor</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-5 w-5 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                      </svg>
                      <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Eventos Especiais</span> como feriados, promoções e lançamentos</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-5 w-5 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                      </svg>
                      <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Dados Competitivos</span> e análise de concorrência</span>
                    </li>
                  </ul>
                  <p className="text-gray-700 dark:text-gray-300">
                    Nossa plataforma integra e pondera automaticamente esses fatores, criando um modelo holístico que captura a complexidade real do seu ambiente de negócios para previsões mais precisas.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Como Funciona */}
          <div className="mt-20">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-8 text-center">Como o Lupa Cast Funciona?</h2>
            <div className="relative">
              {/* Linha conectora */}
              <div className="hidden md:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-lupa-purple via-lupa-orange to-lupa-yellow transform -translate-y-1/2 z-0"></div>
              
              <div className="grid grid-cols-1 md:grid-cols-4 gap-8 relative z-10">
                <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg text-center">
                  <div className="w-16 h-16 mx-auto bg-lupa-purple rounded-full flex items-center justify-center mb-4">
                    <span className="text-2xl font-bold text-white">1</span>
                  </div>
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Coleta de Dados</h3>
                  <p className="text-gray-700 dark:text-gray-300">
                    Integramos seus dados históricos de vendas, estoque, marketing e outras fontes relevantes para criar uma base sólida para análise.
                  </p>
                </div>
                <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg text-center">
                  <div className="w-16 h-16 mx-auto bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                    <span className="text-2xl font-bold text-white">2</span>
                  </div>
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Processamento Avançado</h3>
                  <p className="text-gray-700 dark:text-gray-300">
                    Nossos algoritmos de Machine Learning processam os dados, identificando padrões, tendências e correlações que humanos dificilmente perceberiam.
                  </p>
                </div>
                <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg text-center">
                  <div className="w-16 h-16 mx-auto bg-lupa-yellow rounded-full flex items-center justify-center mb-4">
                    <span className="text-2xl font-bold text-white">3</span>
                  </div>
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Geração de Previsões</h3>
                  <p className="text-gray-700 dark:text-gray-300">
                    O sistema gera previsões precisas para diferentes horizontes temporais, com intervalos de confiança e análise de cenários alternativos.
                  </p>
                </div>
                <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg text-center">
                  <div className="w-16 h-16 mx-auto bg-lupa-purple-dark rounded-full flex items-center justify-center mb-4">
                    <span className="text-2xl font-bold text-white">4</span>
                  </div>
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Interação Conversacional   (opcional)</h3>
                  <p className="text-gray-700 dark:text-gray-300">
                    Com a integração LIA, você pode conversar com seus dados, fazer perguntas específicas e obter insights contextualizados em linguagem natural.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Aplicações Setoriais */}
          <div className="mt-20">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-8 text-center">Aplicações por Setor</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg">
                <div className="w-16 h-16 bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                  <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Varejo</h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Otimize seu planejamento de estoque, preveja demanda por SKU e maximize as vendas com previsões precisas por categoria, loja e região.
                </p>
                <ul className="space-y-2">
                  <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                    <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                    </svg>
                    Previsão de vendas por categoria
                  </li>
                  <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                    <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                    </svg>
                    Otimização de estoque e reposição
                  </li>
                  <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                    <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                    </svg>
                    Planejamento de promoções
                  </li>
                </ul>
              </div>
              <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg">
                <div className="w-16 h-16 bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                  <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Indústria</h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Alinhe produção com demanda, otimize sua cadeia de suprimentos e reduza custos com previsões precisas de necessidades de matéria-prima.
                </p>
                <ul className="space-y-2">
                  <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                    <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                    </svg>
                    Planejamento de produção
                  </li>
                  <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                    <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                    </svg>
                    Gestão de matéria-prima
                  </li>
                  <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                    <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                    </svg>
                    Manutenção preditiva
                  </li>
                </ul>
              </div>
              <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg">
                <div className="w-16 h-16 bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                  <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Farmacêutico</h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Preveja demanda por medicamentos, otimize distribuição e garanta disponibilidade de produtos essenciais com previsões precisas.
                </p>
                <ul className="space-y-2">
                  <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                    <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                    </svg>
                    Gestão de estoque de medicamentos
                  </li>
                  <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                    <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                    </svg>
                    Planejamento de distribuição
                  </li>
                  <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                    <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                    </svg>
                    Previsão de demanda sazonal
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Integração com LIA */}
          <div className="mt-20">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-8 text-center">Quando Seus Dados Conversam com Você</h2>
            <div className="bg-gradient-to-r from-lupa-purple/10 to-lupa-orange/10 dark:from-lupa-purple/20 dark:to-lupa-orange/20 p-8 rounded-xl shadow-lg">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                <div>
                  <h3 className="text-2xl font-bold text-lupa-purple dark:text-white mb-4">A Integração Lupa Cast + LIA</h3>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    Imagine poder perguntar diretamente aos seus dados: "Por que as vendas caíram em março?" ou "Qual produto terá maior crescimento no próximo trimestre?". Com a integração entre o Lupa Cast e nossa <Link to="/solucoes/lia" className="text-lupa-orange hover:underline">solução LIA</Link>, isso se torna realidade.
                  </p>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    A LIA (Lupa Inteligência Artificial) é nossa plataforma de IA conversacional que, quando integrada ao Lupa Cast, cria uma experiência revolucionária onde seus dados literalmente ganham voz.
                  </p>
                  <h4 className="text-xl font-bold text-lupa-purple dark:text-white mt-6 mb-3">Como funciona:</h4>
                  <ul className="space-y-3">
                    <li className="flex items-start">
                      <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
                      <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Perguntas em Linguagem Natural:</span> Faça perguntas complexas como se estivesse conversando com um analista especializado.</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
                      <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Respostas Contextualizadas:</span> Receba explicações detalhadas sobre as previsões, com fatores causais e correlações identificadas.</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
                      <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Exploração de Cenários:</span> Pergunte "E se aumentarmos o preço em 5%?" ou "O que aconteceria se lançássemos o produto em abril em vez de junho?"</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
                      <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Recomendações Proativas:</span> A LIA pode alertar sobre tendências emergentes ou oportunidades que você nem sabia que deveria procurar.</span>
                    </li>
                  </ul>
                </div>
                <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg">
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-4">Exemplo de Interação</h3>
                  <div className="space-y-4">
                    <div className="flex">
                      <div className="flex-shrink-0 mr-3">
                        <div className="w-10 h-10 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center">
                          <svg className="h-6 w-6 text-gray-500 dark:text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                          </svg>
                        </div>
                      </div>
                      <div className="bg-gray-100 dark:bg-gray-700 rounded-lg p-3 max-w-md">
                        <p className="text-gray-700 dark:text-gray-300">Por que as vendas da linha de produtos premium caíram 15% no último trimestre?</p>
                      </div>
                    </div>
                    <div className="flex justify-end">
                      <div className="bg-lupa-purple/10 dark:bg-lupa-purple/20 rounded-lg p-3 max-w-md mr-3">
                        <p className="text-gray-700 dark:text-gray-300">A queda de 15% nas vendas da linha premium foi causada principalmente por três fatores: 1) Aumento de preço de 8% implementado em janeiro, 2) Entrada de um novo concorrente com preços 12% menores, e 3) Redução de 30% no orçamento de marketing digital para esta linha. Os dados mostram que o impacto do aumento de preço foi mais significativo nas regiões Sul e Sudeste, onde a elasticidade-preço é maior.</p>
                      </div>
                      <div className="flex-shrink-0">
                        <div className="w-10 h-10 bg-lupa-orange rounded-full flex items-center justify-center">
                          <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="flex">
                      <div className="flex-shrink-0 mr-3">
                        <div className="w-10 h-10 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center">
                          <svg className="h-6 w-6 text-gray-500 dark:text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                          </svg>
                        </div>
                      </div>
                      <div className="bg-gray-100 dark:bg-gray-700 rounded-lg p-3 max-w-md">
                        <p className="text-gray-700 dark:text-gray-300">O que aconteceria se voltássemos ao preço anterior e dobrássemos o investimento em marketing digital?</p>
                      </div>
                    </div>
                    <div className="flex justify-end">
                      <div className="bg-lupa-purple/10 dark:bg-lupa-purple/20 rounded-lg p-3 max-w-md mr-3">
                        <p className="text-gray-700 dark:text-gray-300">Baseado nos modelos preditivos e elasticidade histórica, retornar ao preço anterior e dobrar o investimento em marketing digital resultaria em um aumento projetado de 22-28% nas vendas da linha premium nos próximos 3 meses. O ROI estimado do investimento adicional em marketing seria de 3.2x. Recomendo focar o investimento em canais digitais com maior conversão histórica: Instagram (42%) e Google Search (35%).</p>
                      </div>
                      <div className="flex-shrink-0">
                        <div className="w-10 h-10 bg-lupa-orange rounded-full flex items-center justify-center">
                          <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Casos de Sucesso */}
          <div className="mt-20">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-8 text-center">Aplicações Reais</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
                <div className="h-3 bg-lupa-orange"></div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Rede de Farmácias Nacional</h3>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    Implementação do Lupa Cast para previsão de demanda de medicamentos por filial, resultando em redução em rupturas de estoque e aumento nas vendas de produtos sazonais.
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-500 dark:text-gray-400">Setor Farmacêutico</span>
                    <span className="text-lupa-orange font-medium">ROI: 420%</span>
                  </div>
                </div>
              </div>
              <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
                <div className="h-3 bg-lupa-orange"></div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Indústria de Alimentos</h3>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    Utilização do Lupa Cast para otimização da cadeia produtiva, resultando em redução no desperdício de matéria-prima e diminuição no tempo de reposição de estoque.
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-500 dark:text-gray-400">Setor Industrial</span>
                    <span className="text-lupa-orange font-medium">ROI: 380%</span>
                  </div>
                </div>
              </div>
              <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
                <div className="h-3 bg-lupa-orange"></div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Varejista de Moda</h3>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    Implementação do Lupa Cast com integração LIA para previsão de tendências de moda, resultando em redução em remarcações de preço e aumento na margem de lucro.
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-500 dark:text-gray-400">Setor de Varejo</span>
                    <span className="text-lupa-orange font-medium">ROI: 510%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Tecnologias Relacionadas */}
          <div className="mt-20">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-8 text-center">Tecnologias Relacionadas</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <Link to="/tecnologias/machine-learning" className="bg-white dark:bg-gray-800 p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-lupa-orange group">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-lupa-orange rounded-full flex items-center justify-center mr-4">
                    <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-lupa-purple dark:text-white group-hover:text-lupa-orange transition-colors duration-300">Machine Learning</h3>
                </div>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Conheça mais sobre as tecnologias de Machine Learning que potencializam o Lupa Cast e permitem previsões cada vez mais precisas e adaptáveis ao seu negócio.
                </p>
                <div className="mt-4 text-lupa-orange font-medium flex items-center">
                  Saiba mais sobre Machine Learning
                  <svg className="ml-2 h-5 w-5 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </div>
              </Link>
              <Link to="/solucoes/lia" className="bg-white dark:bg-gray-800 p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-lupa-orange group">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-lupa-purple rounded-full flex items-center justify-center mr-4">
                    <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-lupa-purple dark:text-white group-hover:text-lupa-orange transition-colors duration-300">LIA - Lupa Inteligência Artificial</h3>
                </div>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Descubra como nossa solução de IA conversacional pode se integrar ao Lupa Cast, permitindo que você converse com seus dados e obtenha insights mais profundos e contextualizados.
                </p>
                <div className="mt-4 text-lupa-orange font-medium flex items-center">
                  Conheça a LIA
                  <svg className="ml-2 h-5 w-5 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </div>
              </Link>
            </div>
          </div>

          {/* Call to Action Final */}
          <div className="mt-20 text-center bg-gradient-to-r from-lupa-purple to-lupa-purple-dark p-12 rounded-xl shadow-inner">
            <h2 className="text-3xl font-bold text-white mb-4">Transforme Suas Previsões em Conversas Estratégicas</h2>
            <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto">
              Descubra como o Lupa Cast pode revolucionar seu planejamento de vendas e estoque com previsões precisas e insights conversacionais que impulsionam resultados reais.
            </p>
            <a href="/contato" className="bg-white text-lupa-purple hover:bg-gray-100 px-8 py-3 rounded-lg font-bold text-lg shadow-lg hover:shadow-xl transition-all duration-300">
              Agende uma Demonstração
            </a>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default LupaCastPage;
